module.exports = __webpack_public_path__ + "img/calendar-item.21ff82d9.svg";